import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DomesticInternationalAlertComponent } from './domestic-international-alert.component';
import { i18nModule } from '@nibtravel/shared/util/i18n';

@NgModule({
  imports: [
    CommonModule,
    i18nModule.forChild({
      scope: 'qqc',
      alias: 'qqc',
    }),
  ],
  declarations: [DomesticInternationalAlertComponent],
  exports: [DomesticInternationalAlertComponent],
})
export class DomesticInternationalAlertModule {}
